export default "__VITE_ASSET__C0Wu2$cX__"